import { Breadcrumb } from '@components/breadcrumb';
import { useCallback, useState } from 'react';
import { useFragment } from 'react-relay';
import { useNavigate } from 'react-router-dom';
import { Content, Rejected, visitorInfoPageFragment } from './lib';
import type { VisitorInfoPagePropsType } from './types';

export const VisitorInfoPage: React.FC<VisitorInfoPagePropsType> = ({ page: pageKey, visitorInfo, setVisitorInfoFn, isRejected: isRejectedProp, storageKey = 'visitorInfo' }) => {
  const navigate = useNavigate();
  const page = useFragment(visitorInfoPageFragment, pageKey);

  const [isRejected, setIsRejected] = useState(isRejectedProp);

  // Keep the in-progress selection in local state. Calling setVisitorInfoFn
  // marks the visitor info as "provided" and dismisses this disclaimer, so it
  // must only happen on confirm - not while the user is still choosing options.
  const [selection, setSelection] = useState(visitorInfo ?? { code: '', country: null });

  const onVisitorTypeChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setSelection((prev) => ({ ...prev, code: event.target.value }));
  }, []);

  const onReject = useCallback(() => {
    setIsRejected(true);
  }, []);

  const onRejectedGoBack = useCallback(() => {
    setIsRejected(false);
    navigate('/');
  }, [navigate]);

  const onConfirm = useCallback(() => {
    const country = selection.country || 'AT';
    const code = selection.code || 'private';

    sessionStorage.setItem(
      storageKey,
      JSON.stringify({
        country,
        code,
      }),
    );

    setVisitorInfoFn({
      country,
      code,
    });
  }, [setVisitorInfoFn, storageKey, selection.country, selection.code]);

  return (
    <div className="relative max-w-205 mx-auto [&_h1]:font-normal [&_h3]:font-serif [&_h3]:text-xl [&_h3]:leading-7 [&_h3]:text-black [&_h3]:font-normal [&_h3]:mb-8 max-[1100px]:mx-[25px] max-[1100px]:[&_h1]:mb-4! max-[1100px]:[&_h3]:mb-4 max-[1100px]:[&_h3]:leading-6 max-[1100px]:[.breadcrumb]:pb-[25px]">
      <Breadcrumb data={page.breadcrumbs} />
      {isRejected ? (
        <Rejected title={page.rejectedTitle} text={page.rejectedText} label={page.rejectedButtonLabel} onRejectedGoBack={onRejectedGoBack} />
      ) : (
        <Content page={page} visitorInfo={selection} setVisitorInfo={setSelection} onReject={onReject} onConfirm={onConfirm} onVisitorTypeChange={onVisitorTypeChange} />
      )}
    </div>
  );
};
